window.TeamInteractionsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.InteractionsServerBaseURL);

    //List brands announcements
    self.getBrandAnnouncements = function (brandId, status, offset, limit) {
        var deferred = $q.defer();

        var params = {
            offset: offset,
            limit: limit,
            status: status
        };

        _protected.request("brands/" + brandId + "/announcements", "GET", params)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Announcements Management / Update brand announcement
    self.updateBrandAnnouncement = function (brandId, announcementId, payload) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/announcements/" + announcementId, "PUT", payload)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Announcements Management / Remove brand announcement image
    self.removeBrandAnnouncementImage = function (brandId, announcementId, payload) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/announcements/" + announcementId + "/remove_image", "DELETE")
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Announcements Management / Publish brand announcement
    self.publishBrandAnnouncement = function (brandId, announcementId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/announcements/" + announcementId + "/publish", "PUT")
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Announcements Management / Unpublish brand announcement
    self.unpublishBrandAnnouncement = function (brandId, announcementId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/announcements/" + announcementId + "/unpublish", "PUT")
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Announcements Management / Delete brand announcement
    self.deleteBrandAnnouncement = function (brandId, announcementId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/announcements/" + announcementId, "DELETE")
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    // FEEDBACK APIS

    //List brands feedback
    self.getBrandFeedbacks = function (brandId, status, offest, limit) {
        var deferred = $q.defer();

        var params = {
            offset: offest,
            limit: limit,
            status: status
        };

        _protected.request("brands/" + brandId + "/feedbacks", "GET", params)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Feedback Management / Update brand feedback
    self.updateBrandFeedback = function (brandId, feedbackId, payload) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId, "PUT", payload)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * remove brand feedback image
     * @param brandId
     * @param feedbackId
     * @param payload
     */
    self.removeBrandFeedbackImage = function (brandId, feedbackId, payload) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId + "/remove_image", "DELETE")
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };


    //Feedbacks Management / publish feedback
    self.publishBrandfeedback = function (brandId, feedbackId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId + "/publish", "PUT", {})
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    //Feedbacks Management / unpublish feedback
    self.unpublishBrandfeedback = function (brandId, feedbackId) {
        var deferred = $q.defer();
        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId + "/unpublish", "PUT", {})
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Get feedback details
     * @param brandId
     * @param feedbackId
     */
    self.getFeedbackById = function (brandId, feedbackId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId, "GET", {})
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data.feedback);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * get feedback active period
     * @param brandId
     * @param feedbackId
     */
    self.getFeedbackActivePeriod = function (brandId, feedbackId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId + "/report/active_period", "GET", {})
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data.active_period);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getFeedbackAnswers = function (brandId, feedbackId, offsetDay, days, offsetDayIncluded, endDate, canceller) {
        var deferred = $q.defer();

        var params = {};
        params.offset_day = moment(offsetDay).format("YYYY-MM-DD");
        params.days = days;
        if(offsetDayIncluded) {
            params.offset_day_included = offsetDayIncluded;
        }

        if(endDate){
            params.end_date = endDate;
        }

        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId + "/report", "GET", params, false, canceller)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data.report);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * deletes Feedback
     * @param brandId
     * @param feedbackId
     */
    self.deleteBrandFeedback = function (brandId, feedbackId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request("brands/" + brandId + "/feedbacks/" + feedbackId , "DELETE", params)
            .then(function (res) {
                    if (res.data && res.status == 200 && res.data.data) {
                        deferred.resolve(res.data.data.report);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getAnnouncementsSettings = cacheService.cache(function (groupId, params) {
        var defer = $q.defer();
        var url = 'brands/' + groupId + '/announcements/settings';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    })[0];

    self.getAnnouncementActionsReport = function (groupId, params) {
        var defer = $q.defer();
        var url = 'reports/brands/' + groupId + '/announcement/actions';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAnnouncementActionsActionsStats = function (groupId, params) {
        var defer = $q.defer();
        var url = 'reports/brands/' + groupId + '/announcement/actions/stats';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };
};
